import React, { Component } from 'react';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import Help32 from '@carbon/icons-react/lib/help--filled/32';
import Request32 from '@carbon/icons-react/lib/request-quote/32';
import DocumentView32 from '@carbon/icons-react/lib/document--view/32';
import PlayFilled64 from '@carbon/icons-react/lib/play--filled/32';
import Events32 from '@carbon/icons-react/lib/events/32';
import Launch32 from '@carbon/icons-react/lib/launch/16';
import  CacheStorage  from '../../helpers/api/CacheStorage'; // A1_CTRL_F5_Issue_After_New_Deploy

export class Support extends Component {
  constructor(props) {
    super(props);
    this.cacheStorage = new CacheStorage(); // A1_CTRL_F5_Issue_After_New_Deploy
  }
  static displayName = Support.name;

  // A1_CTRL_F5_Issue_After_New_Deploy
  showCurrentVersion = (currentCache) => (
    <div className="supportcurrentversion">
       Current Version :  {currentCache}
    </div>
  );
  //End

  render() {
    const currentCache = this.cacheStorage.cacheVersion(); //A1_CTRL_F5_Issue_After_New_Deploy
    return (
      <>
        {/* A1_CTRL_F5_Issue_After_New_Deploy */}
        <PageBreadCrumb linkTo={'/'} linkText="Home" titleLeft="Support" showCurrentVersion={this.showCurrentVersion(currentCache)} /> 
        <div className="mainContainer">
          <div className="bx--col-lg-12">
            <h3 className="description-page">Do you need help?</h3>
            <div className="supportMargin">
              {/* RITM1140879 */}
              <div class="bx--row">
                <div className="supportTitle">
                  <a
                    className="suppTitle"
                    href="https://apps.powerapps.com/play/e/1a767bbf-7750-e95e-a1ae-e070bd520844/a/52929589-e0c0-471d-9ac3-6c3121e4b133?tenantId=7a823e81-3527-485c-a629-67235afb2fa8&sourcetime=1731582132828&hidenavbar=true"
                    >
                      <img width="32px" height="32px" src="/images/icon.svg" />
                  </a>
                </div>
                <div class="supportText">
                  Request the Insight Profile Creation /Modification
                  <a
                    className="suppTitle"
                    href="https://apps.powerapps.com/play/e/1a767bbf-7750-e95e-a1ae-e070bd520844/a/52929589-e0c0-471d-9ac3-6c3121e4b133?tenantId=7a823e81-3527-485c-a629-67235afb2fa8&sourcetime=1731582132828&hidenavbar=true"
                  >
                    {' '}
                    Go to Insight User Profile Request Form  <Launch32 />
                  </a>
                </div>
              </div>
              <div class="bx--row">
                <div className="supportTitle">
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/HSE-PrometheusEvolution-NTTDATA/Shared%20Documents/General/InSight%20User%20Guide"
                  > {/* RITM0634723 */}
                    <DocumentView32 />
                  </a>
                </div>
                <div class="supportText">
                  Read the User Guide to best learn every aspect of InSight!
                  <a
                    className="suppTitle"
                    // href="https://saipem.sharepoint.com/sites/HSE-PrometheusEvolution-NTTDATA/Shared%20Documents/General/InSight%20User%20Guide/Saipem%20InSight%20-%20User%20Guide%20v.7.0.pptx?d=w271415b013bb472abc90c42a70804e2b&csf=1&web=1&e=tleOjh"
                    href="https://saipem.sharepoint.com/sites/HSE-PrometheusEvolution-NTTDATA/Shared%20Documents/General/InSight%20User%20Guide"
                  >
                    {' '}
                    Go to User Guide <Launch32 />
                  </a>
                </div>
              </div>

              <div class="bx--row">
                <div className="supportTitle">
                  {/* RITM1212861 */}
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/InSightVideoTutorial/Shared%20Documents/Forms/AllItems.aspx?web=1&FolderCTID=0x0120007CD14D42CFC41349AF4076CC12635865&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMTgzMjQuMjAyNDAiLCAiT1MiIDogIldpbmRvd3MiIH0%3D&id=%2Fsites%2FInSightVideoTutorial%2FShared%20Documents%2FStream%20Migrated%20Videos"
                  >
                    <PlayFilled64 />
                  </a>
                </div>
                <div class="supportText">
                  Watch the video tutorials to understand how to best interact with InSight!
                  {/* RITM1212861 */}
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/InSightVideoTutorial/Shared%20Documents/Forms/AllItems.aspx?web=1&FolderCTID=0x0120007CD14D42CFC41349AF4076CC12635865&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMTgzMjQuMjAyNDAiLCAiT1MiIDogIldpbmRvd3MiIH0%3D&id=%2Fsites%2FInSightVideoTutorial%2FShared%20Documents%2FStream%20Migrated%20Videos"
                  >
                    {' '}
                    Go to Video Tutorial <Launch32 />{' '}
                  </a>
                </div>
              </div>

              {/* <div class="bx--row">
                <div className="supportTitle">
                  <a className="suppTitle" href="">
                    <Help32 />
                  </a>
                </div>
                <div class="supportText">
                  Please, visit the Frequently Asked Question!
                  <a className="suppTitle" href="">
                    {' '}
                    Go to FAQ <Launch32 />
                  </a>
                </div>
              </div> */}

              <div class="bx--row">
                <div className="supportTitle">
                  <a className="suppTitle" href="https://saipem.sharepoint.com/sites/InSight-Support/Lists/RequestForm/NewForm.aspx"> {/* RITM0634723  */}
                    <Request32 />
                  </a>
                </div>
                <div class="supportText">
                  If Video Tutorial were not useful , please submit your request!
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/InSight-Support/Lists/RequestForm/NewForm.aspx"
                  >
                    {' '}
                    Go to Request Support <Launch32 />{' '}
                  </a>
                </div>
              </div>

              {/* RITM0634723 */}
              {/* RITM0932309 */}
              <div class="bx--row">
                <div className="supportTitle">
                  <a 
                    className="suppTitle" 
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/Shared%20Documents/InSight%20Responsibility%20Matrix/InSight%20-%20Responsibility%20Matrix.pdf?CT=1702372489869&OR=Outlook-Body&CID=5CE7D9EB-9EC0-4D34-AFF0-E05952F3A58F&WSL=1"
                  >
                    <img width="32px" height="32px" src="/images/icon-responsibilityMatrix.svg" />
                  </a>
                </div>
                <div class="supportText">
                  Take a look at the Insight responsibility matrix!
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/Shared%20Documents/InSight%20Responsibility%20Matrix/InSight%20-%20Responsibility%20Matrix.pdf?CT=1702372489869&OR=Outlook-Body&CID=5CE7D9EB-9EC0-4D34-AFF0-E05952F3A58F&WSL=1"
                  >
                    {' '}
                    Go to Insight Responsibility Matrix <Launch32 />{' '}
                  </a>
                </div>
              </div>
              <div class="bx--row">
                <div className="supportTitle">
                  <a 
                    className="suppTitle" 
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/SitePages/Home.aspx?RootFolder=%2Fsites%2FHSEsite%2FNew%20HSE%20Site%2FCorporate%20HSE%2FInSight%2FShared%20Documents%2FTraining%20schedule&FolderCTID=0x0120003C7E13B5DF8DEF4794CE9069AB8C601A&View=%7B66BCB0EF%2D754E%2D467B%2DB0B4%2DA76FBADC0E3C%7D"
                  >
                    <img width="32px" height="32px" src="/images/icon-trainingSchedule.svg" />
                  </a>
                </div>
                <div class="supportText">
                  Take a look at the Training schedule!
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/SitePages/Home.aspx?RootFolder=%2Fsites%2FHSEsite%2FNew%20HSE%20Site%2FCorporate%20HSE%2FInSight%2FShared%20Documents%2FTraining%20schedule&FolderCTID=0x0120003C7E13B5DF8DEF4794CE9069AB8C601A&View=%7B66BCB0EF%2D754E%2D467B%2DB0B4%2DA76FBADC0E3C%7D"
                  >
                    {' '}
                    Go to training schedule <Launch32 />{' '}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
